import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Honors = (props) => {
	if (_.isArray(props.data.honors) && props.data.honors.length) {
		return (
			<ul className="bio-list">{
				_.map(props.data.honors, data => (
					<li className="bio-list__item" key={_.uniqueId('list-item-')}>
						{data.honor_desc}
					</li>
				))}
			</ul>
		);
	}

	return null;
};

Honors.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Honors;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/honors.js